module.exports = __webpack_public_path__ + "static/media/coin-icon.1475c935.png";